module.exports = __webpack_public_path__ + "static/yuksek-kaliteli-trafik-2c609b9ecefb0009f43eecee0cb1b11e.jpg";